import { Link } from "react-router-dom";
import { CONTACT } from "@/content/site";

const TODO = "[DA COMPLETARE]";

function LegalShell({ overline, title, updated, children }) {
  return (
    <div className="bg-canvas text-ink">
      <div className="max-w-3xl mx-auto px-6 md:px-10 pt-36 pb-24">
        <p className="text-[11px] uppercase tracking-[0.35em] text-sagedark mb-4">{overline}</p>
        <h1 className="font-serif font-light text-4xl md:text-5xl tracking-tight leading-[1.05]">{title}</h1>
        {updated && <p className="mt-4 text-sm text-ink/45">Ultimo aggiornamento: {updated}</p>}
        <div className="mt-12 space-y-9 text-[15px] leading-relaxed text-ink/75">{children}</div>
        <div className="mt-16 pt-8 border-t border-ink/10 text-sm">
          <Link to="/" className="link-underline">← Torna alla home</Link>
        </div>
      </div>
    </div>
  );
}

function H2({ children }) {
  return <h2 className="font-serif text-2xl font-light text-ink mb-3">{children}</h2>;
}
function Section({ title, children }) {
  return (
    <section>
      <H2>{title}</H2>
      <div className="space-y-3">{children}</div>
    </section>
  );
}

export function PrivacyPage() {
  return (
    <LegalShell overline="Informativa" title="Privacy Policy">
      <p>
        La presente informativa descrive il trattamento dei dati personali degli utenti che
        consultano questo sito e che utilizzano il modulo di contatto/richiesta di valutazione,
        ai sensi del Regolamento (UE) 2016/679 (GDPR).
      </p>

      <Section title="Titolare del trattamento">
        <p>{CONTACT.legal.fullName} — {CONTACT.legal.role}.</p>
        <p>{CONTACT.legal.ordine} · Iscrizione Albo n. {CONTACT.legal.albo}.</p>
        <p>P.IVA {CONTACT.legal.piva} · C.F. {CONTACT.legal.cf}.</p>
        <p>Sedi di attività: {CONTACT.studios.join(" — ")}.</p>
        <p>Email di contatto per la privacy: <a className="link-underline" href={`mailto:${CONTACT.email}`}>{CONTACT.email}</a>.</p>
        <p className="text-sm text-ink/50">Lo Studio Medico Lazzari è indicato esclusivamente quale sede professionale presso cui il medico esercita e non è contitolare del trattamento dei dati del sito: le richieste inviate tramite modulo e WhatsApp sono ricevute e gestite direttamente dal Dott. Alessandro Valle.</p>
      </Section>

      <Section title="Dati raccolti">
        <p>Tramite il modulo di richiesta raccogliamo esclusivamente: nome e cognome, indirizzo
          email, numero di telefono, tipo di appuntamento e un eventuale messaggio libero.</p>
        <p>Ti invitiamo a <strong>non inserire nel campo libero dati sanitari o particolari</strong>
          (diagnosi, referti, patologie, fotografie cliniche): tali informazioni verranno raccolte,
          se necessario, esclusivamente in sede di visita medica.</p>
        <p>Il sito registra inoltre dati di navigazione tecnici e, previo consenso, dati statistici
          aggregati (vedi <Link className="link-underline" to="/cookie-policy">Cookie Policy</Link>).</p>
      </Section>

      <Section title="Finalità e basi giuridiche">
        <p>• Rispondere alle richieste e fissare un appuntamento — base giuridica: riscontro a una
          tua richiesta / misure precontrattuali (art. 6.1.b GDPR).</p>
        <p>• Adempimenti di legge — obbligo legale (art. 6.1.c GDPR).</p>
        <p>• Statistiche di utilizzo del sito — consenso (art. 6.1.a GDPR), revocabile in ogni momento.</p>
      </Section>

      <Section title="Tempi di conservazione">
        <p>I dati inviati tramite il modulo sono conservati per il tempo necessario a gestire la
          richiesta e comunque non oltre <strong>12 mesi</strong>, salvo diversi obblighi di legge o
          l'instaurarsi di un rapporto professionale.</p>
      </Section>

      <Section title="Destinatari e fornitori (responsabili del trattamento)">
        <p>I dati possono essere trattati da fornitori tecnici che erogano servizi per conto del
          Titolare, tra cui:</p>
        <p>• <strong>Emergent</strong> — hosting dell'applicazione e del database.</p>
        <p>• Servizio di invio email transazionali (notifica della richiesta e conferma all'utente).</p>
        <p>I dati non vengono diffusi né ceduti a terzi per finalità di marketing.</p>
      </Section>

      <Section title="Trasferimenti extra-SEE">
        <p>Qualora alcuni fornitori trattino dati al di fuori dello Spazio Economico Europeo, il
          trasferimento avviene sulla base di garanzie adeguate (es. Clausole Contrattuali Standard).
          Dettaglio fornitori e localizzazione: <strong>{TODO}</strong>.</p>
      </Section>

      <Section title="Diritti dell'interessato">
        <p>Puoi esercitare in ogni momento i diritti di accesso, rettifica, cancellazione,
          limitazione, opposizione e portabilità, oltre a revocare il consenso, scrivendo a{" "}
          <a className="link-underline" href={`mailto:${CONTACT.email}`}>{CONTACT.email}</a>. Hai
          inoltre il diritto di proporre reclamo al Garante per la protezione dei dati personali.</p>
      </Section>

      <p className="text-sm text-ink/45">Nota: il dettaglio dei fornitori e la loro localizzazione, incluse eventuali garanzie per trasferimenti extra‑SEE, sono in fase di verifica con il fornitore di hosting (Emergent) e verranno precisati prima della pubblicazione definitiva.</p>
    </LegalShell>
  );
}

export function CookiePolicyPage() {
  return (
    <LegalShell overline="Informativa" title="Cookie Policy">
      <p>Questo sito utilizza cookie e tecnologie analoghe. Di seguito le categorie utilizzate e le
        modalità per gestire il consenso.</p>

      <Section title="Cookie necessari">
        <p>Indispensabili per il funzionamento del sito e delle sue funzionalità di base. Non
          richiedono consenso.</p>
      </Section>

      <Section title="Cookie statistici">
        <p>Utilizzati, previo tuo consenso, per raccogliere informazioni in forma aggregata su come
          viene utilizzato il sito (strumento di analytics della piattaforma). Non vengono attivati
          finché non presti il consenso e puoi rifiutarli senza limitare la navigazione.</p>
      </Section>

      <Section title="Font e contenuti esterni">
        <p>Il sito utilizza web font (Google Fonts). Non sono presenti, allo stato attuale, mappe,
          video incorporati, pixel pubblicitari o plugin social di terze parti.</p>
      </Section>

      <Section title="Gestione del consenso">
        <p>Puoi modificare o revocare in qualsiasi momento le tue scelte tramite il pulsante
          <strong> “Preferenze cookie”</strong> presente nel footer del sito. Il consenso o il
          rifiuto vengono registrati e rispettati nelle visite successive.</p>
      </Section>

      <p className="text-sm">Vedi anche la <Link className="link-underline" to="/privacy">Privacy Policy</Link>.</p>
    </LegalShell>
  );
}

export function NotFoundPage() {
  return (
    <div className="bg-canvas text-ink min-h-[70vh] flex items-center">
      <div className="max-w-3xl mx-auto px-6 md:px-10 py-40 text-center" data-testid="not-found-page">
        <p className="text-[11px] uppercase tracking-[0.35em] text-sagedark mb-4">Errore 404</p>
        <h1 className="font-serif font-light text-5xl md:text-6xl tracking-tight">Pagina non trovata</h1>
        <p className="mt-6 text-ink/60 max-w-md mx-auto">La pagina che cerchi non esiste o è stata spostata.</p>
        <Link to="/" className="mt-10 inline-flex items-center border border-ink/30 px-8 py-3 text-xs uppercase tracking-[0.2em] hover:bg-ink hover:text-canvas transition-colors">
          Torna alla home
        </Link>
      </div>
    </div>
  );
}
